"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _findLast2 = _interopRequireDefault(require("lodash/findLast"));
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _performanceNow = _interopRequireDefault(require("performance-now"));
var _tabbable = require("tabbable");
var _classnames = _interopRequireDefault(require("classnames"));
var _tween = require("../../helpers/tween");
var _carouselUtils = require("./carousel-utils");
var _events = require("../../utils/events");
var _window = require("./window");
var _getTransformProperty = _interopRequireDefault(require("./get-transform-property"));
var _pagerButton = _interopRequireDefault(require("./pager-button"));
var _carouselControl = _interopRequireDefault(require("./carousel-control"));
require("./carousel.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var sliderTransform;
var win;
var getKeyCode = function getKeyCode(keyEvent) {
  return (keyEvent.which || keyEvent.keyCode || 0).toString();
};
var noop = function noop() {};

/**
 * Allows for an easy way to add elements to a carousel. It was built with accessibility in mind and
 * is fully navigable by tabbing and left/right keys.
 */
var Carousel = exports["default"] = /*#__PURE__*/function (_Component) {
  function Carousel(props) {
    var _this$props$messages;
    var _this;
    _classCallCheck(this, Carousel);
    _this = _callSuper(this, Carousel, [props]);
    _this.bindMethods();
    _this.tweener = new _tween.Tweener();
    _this.state = {
      ariaMessages: _objectSpread({
        ariaLabel: 'Featured cards carousel',
        ariaLabelSlide: 'Slide',
        ariaDescription: function ariaDescription(numberOfSlides) {
          return "Carousel with ".concat(numberOfSlides, " slides");
        },
        ariaLabelNext: 'Next',
        ariaLabelPrev: 'Previous',
        ariaLabelPages: function ariaLabelPages(pageNumber) {
          return "go to page ".concat(pageNumber);
        }
      }, (_this$props$messages = _this.props.messages) !== null && _this$props$messages !== void 0 ? _this$props$messages : {}),
      currentSlide: props.initialCurrentSlide,
      totalPages: (0, _carouselUtils.getNumberOfPages)(props.children.length, props.slidesPerPage),
      selectedPage: (0, _carouselUtils.getPageForSlide)(props.initialCurrentSlide, props.slidesPerPage),
      visibleSlides: []
    };

    // Local interaction and animation state. Managed separately from React state system
    // to prevent rapid re-rendering.
    _this.touchObject = {};
    _this.tweenValue = 0;
    sliderTransform = sliderTransform || (0, _getTransformProperty["default"])();
    _this.wrapperRef = /*#__PURE__*/(0, _react.createRef)();

    // Inform the user if they have invalid props
    if (props.showPaginator && props.variableWidth) {
      // eslint-disable-next-line no-console
      console.error('ERROR: A carousel with a variable width cannot also have a paginator. Please fix to render this carousel.');
      return _possibleConstructorReturn(_this, null);
    }
    return _this;
  }

  // eslint-disable-next-line max-statements
  _inherits(Carousel, _Component);
  return _createClass(Carousel, [{
    key: "bindMethods",
    value: function bindMethods() {
      this.slideBack = this.slideBack.bind(this);
      this.slideForward = this.slideForward.bind(this);
      this.manageScrollToSlide = this.manageScrollToSlide.bind(this);
      this.setSliderPosition = this.setSliderPosition.bind(this);
      this.setCurrentSlide = this.setCurrentSlide.bind(this);
      this.setCurrentPage = this.setCurrentPage.bind(this);
      this.createTouchObject = this.createTouchObject.bind(this);
      this.handleTouchMove = this.handleTouchMove.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleFocus = this.handleFocus.bind(this);
      this.handleDocumentBlur = this.handleDocumentBlur.bind(this);

      // Conditionally binding the different resize methods improves performance
      // vs checking this every time a resize event happens
      if (this.props.resizeDebounceTime === 0) {
        this.handleResize = this.handleInstantResize.bind(this);
      } else if (this.props.resizeDebounceTime <= 42) {
        this.handleResize = (0, _debounce2["default"])(this.handleInstantResize, this.props.resizeDebounceTime).bind(this);
      } else {
        this.handleResize = (0, _debounce2["default"])(this.handleAnimatedResize, this.props.resizeDebounceTime).bind(this);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      win = (0, _window.getWindow)();
      (0, _events.addEventListener)(win, 'resize', this.handleResize);
      if (this.wrapperRef.current) {
        (0, _events.addEventListener)(this.wrapperRef.current, 'scroll', this.handleScroll);
      }
      (0, _events.addEventListener)(document, 'blur', this.handleDocumentBlur, true);
      (0, _events.addEventListener)(win, 'keydown', this.handleKeyDown);
      if (!this.state.carouselId) {
        this.setState({
          carouselId: this.props.id || (0, _uniqueId2["default"])('carousel')
        });
      }

      // Set current slide on mount in order to correctly calculate carousel
      // position and visible slides based on rendered content.
      this.setCurrentSlide(this.state.currentSlide);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.manageScrollToSlide(prevProps);
      this.checkAllSlidesCurrentlyVisible();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _events.removeEventListener)(win, 'resize', this.handleResize);
      if (this.wrapperRef.current) {
        (0, _events.removeEventListener)(this.wrapperRef.current, 'scroll', this.handleScroll);
      }
      (0, _events.removeEventListener)(document, 'blur', this.handleDocumentBlur, true);
      (0, _events.removeEventListener)(win, 'keydown', this.handleKeyDown);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (!this.props.globalKeyBindings) {
        return;
      }

      // If the keydown occurs in an input or textarea element, do nothing.
      if (['INPUT', 'TEXTAREA'].indexOf(e.target.tagName) >= 0) {
        return;
      }
      var key = getKeyCode(e);
      var keyMap = {
        // Left arrow
        37: this.slideBack,
        // Right arrow
        39: this.slideForward
      };
      var keyHandler = keyMap[key];
      if (keyHandler) {
        keyHandler();
      }
    }
  }, {
    key: "getTabbableInSlide",
    value: function getTabbableInSlide(slideIndex) {
      var slideEl = this.getSlideByIndex(slideIndex);
      return (0, _tabbable.tabbable)(slideEl);
    }
  }, {
    key: "manageScrollToSlide",
    value: function manageScrollToSlide(prevProps) {
      var _this2 = this;
      // If there are no slides, suppress carousel behavior.
      if (!this.props.children.length) {
        return;
      }
      this.scrollToSlide(function (status) {
        if (status.scrolled) {
          return;
        }
        var pagerButtonsWereToggled = function pagerButtonsWereToggled() {
          return Boolean(prevProps.showPagerButtons !== _this2.props.showPagerButtons);
        };
        if (prevProps.children !== _this2.props.children || pagerButtonsWereToggled()) {
          // for a re-render of the carousel pages
          _this2.setCurrentSlide(pagerButtonsWereToggled() ? 0 : _this2.state.currentSlide);
        }
      });
    }
  }, {
    key: "slideIsVisible",
    value: function slideIsVisible(index, bounds) {
      var carouselRight = bounds.carouselRight,
        carouselLeft = bounds.carouselLeft,
        sliderOffset = bounds.sliderOffset;
      var slide = this.getSlideBounds(index);
      var slideLeft = slide.left + sliderOffset;
      var slideRight = slide.right + sliderOffset;

      // Check absolute difference between points to account for
      // subpixel rounding errors.
      var leftVisible = Math.abs(slideLeft - carouselLeft) < 1 || slideLeft >= carouselLeft;
      var rightVisible = Math.abs(slideRight - carouselRight) < 1 || slideRight <= carouselRight;
      return leftVisible && rightVisible;
    }
  }, {
    key: "getVisibleSlidesState",
    value: function getVisibleSlidesState() {
      // returns the internal state of the visible slides--this can be used to view slide attributes, such as aria-hidden, allowing the consumer to set focus appropriately (e.g. by applying tabIndex=-1 to that element)
      return this.state.visibleSlides;
    }
  }, {
    key: "getVisibleSlides",
    value: function getVisibleSlides(nextSliderPosition) {
      var visibleSlides = [];
      var domNode = this.wrapperRef.current;
      if (!domNode) {
        return visibleSlides;
      }
      var carouselBounds = domNode.getBoundingClientRect();
      var currentSliderPosition = this.tweenValue;
      var sliderPositionDifference = Math.abs(nextSliderPosition - currentSliderPosition);
      var sliderOffset = nextSliderPosition > currentSliderPosition ? sliderPositionDifference * -1 : sliderPositionDifference;
      var bounds = {
        sliderOffset: sliderOffset,
        carouselRight: carouselBounds.right,
        carouselLeft: carouselBounds.left
      };
      for (var i = 0; i < this.props.children.length; i++) {
        if (this.slideIsVisible(i, bounds)) {
          visibleSlides.push(i);
        } else if (visibleSlides.length) {
          // Visible slides are always contiguous, so stop iterating once we've
          // stopped seeing them.
          break;
        }
      }
      return visibleSlides;
    }
  }, {
    key: "getSliderRightLimit",
    value: function getSliderRightLimit() {
      var lastSlide = this.getSlideByIndex(this.props.children.length - 1);
      var lastSlideOffset = lastSlide.offsetLeft;
      var lastSlideRight = lastSlide.offsetWidth + lastSlideOffset;
      var sliderWidth = this.$slider.offsetWidth;

      // Disregard right slide limits smaller than 0 (which indicates that
      // there are fewer than 1 page of slides, so there's nowhere for the carousel
      // to scroll.)
      return Math.max(lastSlideRight - sliderWidth, 0);
    }
  }, {
    key: "getSliderTargets",
    value: function getSliderTargets(targetSlideIndex) {
      // Exit early if we're on the first slide, which will always be at 0.
      if (targetSlideIndex === 0) {
        return 0;
      }
      var sliderRightLimit = this.getSliderRightLimit();
      var targetSlidePosition = this.getSlideOffset(targetSlideIndex);

      // Subpixel values cause text blurring when used with translate3d.
      // Round to whole pixels to avoid blur.
      return Math.min(Math.round(targetSlidePosition || 0), sliderRightLimit);
    }
  }, {
    key: "scrollToSlide",
    value: function scrollToSlide(callback) {
      // Subpixel values cause text blurring when used with translate3d.
      // Round to whole pixels to avoid blur.
      var startValue = Math.round(this.tweenValue);
      var endValue = this.state.currentSlidePosition;
      if (startValue === endValue) {
        return callback({
          scrolled: false
        });
      }
      this.tweener.cancel();
      this.tweener.init({
        startValue: startValue,
        endValue: endValue,
        springFactor: this.props.springFactor,
        duration: this.props.animationDuration,
        easingFunction: this.props.easingFunction,
        endCallback: function endCallback() {
          callback({
            scrolled: true
          });
        }
      }, this.setSliderPosition);
    }
  }, {
    key: "setSliderPosition",
    value: function setSliderPosition(position) {
      if (this.$slider) {
        var sliderTransformValue = sliderTransform.getValue(position * -1);
        this.$slider.style[sliderTransform.property] = sliderTransformValue;
        this.tweenValue = position;
      }
    }

    /**
     * Moves carousel to a slide.
     * @param {number} slideIndex - The 0-based slide index to move the carousel to.
     * @returns {void}
     */
  }, {
    key: "setCurrentSlide",
    value: function setCurrentSlide(slideIndex) {
      var _this3 = this;
      var _this$props = this.props,
        children = _this$props.children,
        slidesPerPage = _this$props.slidesPerPage;
      var domNode = this.wrapperRef.current;
      var outOfBounds = slideIndex < 0 || slideIndex >= this.props.children.length;
      if (outOfBounds || !domNode) {
        return;
      }
      var callback = this.state.currentSlide === slideIndex ? function () {} : function () {
        _this3.props.onSlideChange(slideIndex);
      };
      var nextSliderPosition = this.getSliderTargets(slideIndex);
      var visibleSlides = this.getVisibleSlides(nextSliderPosition);
      this.setState({
        visibleSlides: visibleSlides,
        currentSlide: slideIndex,
        currentSlidePosition: nextSliderPosition,
        totalPages: (0, _carouselUtils.getNumberOfPages)(children.length, slidesPerPage),
        selectedPage: (0, _carouselUtils.getPageForSlide)(slideIndex, slidesPerPage)
      }, callback);
    }
  }, {
    key: "setFocusInSlide",
    value: function setFocusInSlide(slideIndex) {
      var _this4 = this;
      setTimeout(function () {
        var slideElement = _this4.getSlideByIndex(slideIndex);
        if (slideElement) {
          slideElement.focus();
        }
      }, this.props.animationDuration + 50);
    }
  }, {
    key: "setCurrentPage",
    value: function setCurrentPage(pageIndex) {
      this.setCurrentSlide(pageIndex * this.props.slidesPerPage);
    }
  }, {
    key: "moveToSlide",
    value: function moveToSlide(slideIndex) {
      this.setCurrentSlide(slideIndex);
      this.setFocusInSlide(slideIndex);
    }
  }, {
    key: "getSlideBackTarget",
    value: function getSlideBackTarget(targetSlide) {
      if (targetSlide <= 0) {
        return 0;
      }
      var nextSliderPosition = this.getSliderTargets(targetSlide);
      var nextVisibleSlides = this.getVisibleSlides(nextSliderPosition);
      var lastNextVisibleSlide = nextVisibleSlides[nextVisibleSlides.length - 1];
      if (this.state.visibleSlides.indexOf(lastNextVisibleSlide) === -1) {
        return targetSlide;
      }
      return this.getSlideBackTarget(targetSlide - 1);
    }

    /**
     * Moves carousel back one page.
     * @returns {void}
     */
  }, {
    key: "slideBack",
    value: function slideBack() {
      var targetSlide = this.props.variableWidth ? this.getSlideBackTarget(this.state.visibleSlides[0] - 1) : this.state.currentSlide - this.props.slidesPerPage;
      this.moveToSlide(targetSlide);
    }

    /**
     * Moves carousel forward one page.
     * @returns {void}
     */
  }, {
    key: "slideForward",
    value: function slideForward() {
      var visibleSlides = this.state.visibleSlides;
      var targetSlide = this.props.variableWidth ? visibleSlides[visibleSlides.length - 1] + 1 : this.state.currentSlide + this.props.slidesPerPage;
      this.moveToSlide(targetSlide);
    }

    /* eslint-disable max-params*/
  }, {
    key: "getSwipeDirection",
    value: function getSwipeDirection(x1, x2, y1, y2) {
      var xDist = x1 - x2;
      var yDist = y1 - y2;
      var r = Math.atan2(yDist, xDist);
      var swipeAngle = Math.round(r * 180 / Math.PI) - 90;
      if (swipeAngle < 0) {
        swipeAngle = 360 - Math.abs(swipeAngle);
      }
      var swipeAngleThreshold = 30;
      if (Math.abs(swipeAngle - 90) <= swipeAngleThreshold) {
        return -1;
      } else if (Math.abs(swipeAngle - 270) <= swipeAngleThreshold) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "getSlideByIndex",
    value: function getSlideByIndex(slideIndex) {
      return this["$slide-".concat(slideIndex)] || {};
    }
  }, {
    key: "getSlideBounds",
    value: function getSlideBounds(slideIndex) {
      return this.getSlideByIndex(slideIndex).getBoundingClientRect();
    }
  }, {
    key: "getSlideOffset",
    value: function getSlideOffset(slideIndex) {
      return this.getSlideByIndex(slideIndex).offsetLeft;
    }
  }, {
    key: "getSliderPosition",
    value: function getSliderPosition() {
      return this.getSlideOffset(this.state.currentSlide);
    }

    /* eslint-disable max-statements */
  }, {
    key: "findClosestSlide",
    value: function findClosestSlide(swipeAmount) {
      var currentSlide = this.state.currentSlide;
      var domNode = this.wrapperRef.current;
      if (!domNode) {
        return currentSlide;
      }
      var lastSlide = this.props.children.length - 1;
      var lastSlideBounds = this.getSlideBounds(lastSlide);
      var carouselBounds = domNode.getBoundingClientRect();
      var carouselLeft = carouselBounds.left;
      var swipeTarget = swipeAmount + carouselLeft;
      if (swipeTarget > lastSlideBounds.left) {
        return lastSlide;
      }
      for (var i = 0; i < this.props.children.length; i++) {
        var slideBounds = this.getSlideBounds(i);
        var slideWidth = slideBounds.width;
        var slideLeft = slideBounds.left;
        var slideRight = slideBounds.right;
        var partialWidth = slideWidth * 0.2;
        var leftVisible = swipeTarget > 0 && slideLeft + partialWidth >= swipeTarget;
        var rightVisible = swipeTarget < 0 && slideRight - partialWidth >= swipeTarget;
        if (swipeTarget === 0) {
          // If slider is not moving and at least 50%
          // of the slide is on screen, select it.
          if (Math.abs(slideLeft) < slideWidth / 2) {
            currentSlide = i;
            break;
          }
        } else if (leftVisible || rightVisible) {
          // If slider is moving and more than 1/5 of the slide
          // will be visible at the swipe target, select it.
          currentSlide = i;
          break;
        }
      }
      return currentSlide;
    }
    /* eslint-enable max-statements */
  }, {
    key: "checkAllSlidesCurrentlyVisible",
    value: function checkAllSlidesCurrentlyVisible() {
      if (!this.props.areAllSlidesCurrentlyVisible) {
        return;
      }
      var visibleSlides = this.getVisibleSlides(0);
      this.props.areAllSlidesCurrentlyVisible(visibleSlides.length === this.props.children.length);
    }

    // Calculate distance based on given velocity
    // (and arbitrary amount of friction that feels right)
    // http://metafizzy.co/blog/math-time-resting-position/
  }, {
    key: "calculateSwipeDistance",
    value: function calculateSwipeDistance(swipeVelocity) {
      var friction = 0.01;
      var velocity = swipeVelocity;
      var distance = 0;

      // Stop at 0.02 because this will approach 0 forever otherwise.
      while (Math.abs(velocity) > 0.02) {
        velocity *= 1 - friction;
        distance += velocity;
      }
      return distance;
    }
  }, {
    key: "handleSwipe",
    value: function handleSwipe() {
      if (!this.touchObject.length) {
        this.touchObject = {};
        return;
      }
      var touches = this.touchObject.touches;
      var time = (0, _performanceNow["default"])();
      var swipeStart = (0, _findLast2["default"])(touches, function (touch) {
        return time - touch.time >= 50;
      }) || touches[0];
      var swipeEnd = touches[touches.length - 1];
      var duration = time - swipeStart.time;
      var swipeVelocity = (swipeStart.x - swipeEnd.x) / duration;
      var direction = this.getSwipeDirection(swipeStart.x, swipeEnd.x, swipeStart.y, swipeEnd.y);
      var swipeTarget = direction === 0 ? 0 : this.calculateSwipeDistance(swipeVelocity);
      var closestSlide = this.findClosestSlide(swipeTarget);
      this.setCurrentSlide(closestSlide);
      this.touchObject = {};
    }
  }, {
    key: "createTouchObject",
    value: function createTouchObject(e) {
      this.touchObject = {
        lastSlideOffset: this.getSlideOffset(this.props.children.length - 1),
        sliderStartValue: this.tweenValue,
        touches: [{
          time: (0, _performanceNow["default"])(),
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        }]
      };
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(e) {
      var _e$changedTouches;
      var currentTouch = e.touches[0];
      var touchObjectExists = Boolean(this.touchObject.touches);
      if (!touchObjectExists) {
        this.createTouchObject(e);
      }
      var firstTouch = this.touchObject.touches[0];
      var direction = this.getSwipeDirection(firstTouch.x, currentTouch.pageX, firstTouch.y, currentTouch.pageY);
      if (direction !== 0 && ((_e$changedTouches = e.changedTouches) === null || _e$changedTouches === void 0 ? void 0 : _e$changedTouches.length) > 1) {
        e.preventDefault();
      }
      this.touchObject.length = Math.round(Math.abs(currentTouch.pageX - firstTouch.x));
      this.touchObject.touches.push({
        time: (0, _performanceNow["default"])(),
        x: currentTouch.pageX,
        y: currentTouch.pageY
      });
      var touchValue = this.getTouchValue(this.touchObject, direction);
      this.setSliderPosition(touchValue);
    }
  }, {
    key: "getTouchValue",
    value: function getTouchValue(touchObject, direction) {
      var touchValue = touchObject.sliderStartValue + touchObject.length * direction;
      if (touchValue < 0) {
        return Math.sqrt(Math.abs(touchValue)) * -1;
      }
      if (touchValue > touchObject.lastSlideOffset) {
        var touchValueOverflow = touchValue - touchObject.lastSlideOffset;
        return touchObject.lastSlideOffset + Math.sqrt(touchValueOverflow);
      }
      return touchValue;
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd(e) {
      this.handleSwipe(e);
    }
  }, {
    key: "handleAnimatedResize",
    value: function handleAnimatedResize() {
      this.setCurrentSlide(this.state.currentSlide);
    }
  }, {
    key: "handleInstantResize",
    value: function handleInstantResize() {
      // Immediately adjust transform to the current target during resize without any animation
      this.setSliderPosition(this.getSliderTargets(this.state.currentSlide));

      // Still call setCurrentSlide to set state properly even though no animation will be needed
      this.setCurrentSlide(this.state.currentSlide);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if (this.inCurrentSlides(e.target)) {
        return;
      }
      var tabbables = (0, _tabbable.tabbable)(document.body);
      var lastBlurredIndex = tabbables.indexOf(this.lastBlurred);
      var targetIndex = tabbables.indexOf(e.target);
      this.setFocus({
        tabbables: tabbables,
        targetIndex: targetIndex,
        forward: lastBlurredIndex < targetIndex
      });
    }
  }, {
    key: "setFocus",
    value: function setFocus(_ref) {
      var _this5 = this;
      var forward = _ref.forward,
        tabbables = _ref.tabbables,
        targetIndex = _ref.targetIndex;
      var startIndex = forward ? targetIndex + 1 : targetIndex - 1;
      var _loop = function _loop() {
          var item = tabbables[i];
          if (!_this5.$slider.contains(item) || _this5.inCurrentSlides(item)) {
            setTimeout(function () {
              item.focus();
            }, 1);
            return {
              v: void 0
            };
          }
        },
        _ret;
      for (var i = startIndex; i < tabbables.length && i >= 0; forward ? i++ : i--) {
        _ret = _loop();
        if (_ret) return _ret.v;
      }

      // If we can't find any elements, we're at the end of the page, so we reset.
      // This is non ideal because it doesn't preserve default browser behavior in which
      // pressing shift tab takes you directly back to the last element. Instead, it acts
      // as if you've hit the page from the start and are trying to tab backwards,
      // requiring extra keystrokes.
      tabbables[0].focus();
      tabbables[0].blur();
    }
  }, {
    key: "inCurrentSlides",
    value: function inCurrentSlides(target) {
      for (var i = 0; i < this.state.visibleSlides.length; i++) {
        var slideEl = this.getSlideByIndex(this.state.visibleSlides[i]);
        if (slideEl.contains(target)) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "handleDocumentBlur",
    value: function handleDocumentBlur(e) {
      this.lastBlurred = e.target;
    }
  }, {
    key: "addChildProps",
    value: function addChildProps(children) {
      var _this6 = this;
      if (_typeof(children) !== 'object') return null;
      var visibleSlides = this.state.visibleSlides;
      var slideClassName = {
        1: 'size12of12',
        2: 'size6of12',
        3: 'size4of12',
        4: 'size3of12',
        5: 'size1of5',
        6: 'size2of12'
      }["".concat(this.props.slidesPerPage)];
      var ariaLabelSlide = this.state.ariaMessages.ariaLabelSlide;
      if (this.props.variableWidth) {
        return _react["default"].Children.map(children, function (slide, idx) {
          var slideNotVisible = (visibleSlides === null || visibleSlides === void 0 ? void 0 : visibleSlides.indexOf(idx)) === -1;
          var slideIndex = idx + 1;
          var className = slide.props.className || '';
          var slideRef = slide.ref;
          return /*#__PURE__*/_react["default"].cloneElement(slide, {
            ref: function ref(el) {
              _this6["$slide-".concat(idx)] = el;
              slideRef && slideRef(el);
            },
            'aria-hidden': slideNotVisible,
            'aria-label': "".concat(ariaLabelSlide, " ").concat(slideIndex),
            className: (0, _classnames["default"])('carousel__sliderItem', className, _defineProperty({}, _this6.props.inactiveSlideClassName, slideNotVisible)),
            key: idx,
            // Add tabindex to make the element focusable if it's not already
            tabIndex: -1
          });
        });
      }
      return _react["default"].Children.map(children, function (slide, idx) {
        var slideNotVisible = (visibleSlides === null || visibleSlides === void 0 ? void 0 : visibleSlides.indexOf(idx)) === -1;
        var slideIndex = idx + 1;
        return /*#__PURE__*/_react["default"].createElement("div", {
          "aria-hidden": slideNotVisible,
          "aria-label": "".concat(ariaLabelSlide, " ").concat(slideIndex),
          className: (0, _classnames["default"])('carousel__sliderItem gridItem', slideClassName, _defineProperty({}, _this6.props.inactiveSlideClassName, slideNotVisible)),
          key: idx,
          ref: function ref(el) {
            return _this6["$slide-".concat(idx)] = el;
          }
          // Add tabindex to make the element focusable if it's not already
          ,
          tabIndex: -1
        }, slide);
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var children = this.addChildProps(this.props.children);
      return children;
    }
  }, {
    key: "getPagerProps",
    value: function getPagerProps() {
      var visibleSlides = this.state.visibleSlides;
      var _this$props2 = this.props,
        children = _this$props2.children,
        snapPagersToImages = _this$props2.snapPagersToImages;
      return {
        visibleSlides: visibleSlides,
        children: children,
        snapPagersToImages: snapPagersToImages,
        firstSlide: this.getSlideByIndex(0),
        firstVisibleSlide: visibleSlides[0],
        lastVisibleSlide: visibleSlides[visibleSlides.length - 1],
        clickHandlers: {
          prev: this.slideBack,
          next: this.slideForward
        }
      };
    }
  }, {
    key: "imgDidLoad",
    value: function imgDidLoad(img) {
      return Boolean(img.complete && img.naturalHeight > 0);
    }
  }, {
    key: "getSnappedPagerStyle",
    value: function getSnappedPagerStyle() {
      var _this$getPagerProps = this.getPagerProps(),
        firstSlide = _this$getPagerProps.firstSlide;
      if (firstSlide.innerHTML) {
        var img = firstSlide.getElementsByTagName('img')[0];
        return img && this.imgDidLoad(img) ? {
          top: "".concat(img.offsetTop, "px"),
          marginTop: "".concat(img.offsetHeight / 2, "px")
        } : null;
      }
      return null;
    }
  }, {
    key: "renderPagerButton",
    value: function renderPagerButton(directionName) {
      var _this7 = this;
      if (!this.props.showPagerButtons) return null;
      var _this$getPagerProps2 = this.getPagerProps(),
        visibleSlides = _this$getPagerProps2.visibleSlides,
        children = _this$getPagerProps2.children,
        snapPagersToImages = _this$getPagerProps2.snapPagersToImages,
        firstVisibleSlide = _this$getPagerProps2.firstVisibleSlide,
        lastVisibleSlide = _this$getPagerProps2.lastVisibleSlide,
        clickHandlers = _this$getPagerProps2.clickHandlers;
      var style = snapPagersToImages ? this.getSnappedPagerStyle() : null;
      var active = false;

      // Pager buttons can be active if there are additional slides
      // in the button's direction. If there are no visible slides or
      // there are no slides in a given direction, the button for that direction
      // is inactive.
      if (visibleSlides.length) {
        if (directionName === 'prev' && firstVisibleSlide !== 0) {
          active = true;
        } else if (directionName === 'next' && lastVisibleSlide !== children.length - 1) {
          active = true;
        }
      }
      return /*#__PURE__*/_react["default"].createElement(_pagerButton["default"], {
        active: active,
        alwaysVisible: this.props.alwaysShowPagerButtons,
        ariaLabelNext: this.state.ariaMessages.ariaLabelNext,
        ariaLabelPrev: this.state.ariaMessages.ariaLabelPrev,
        buttonClassName: this.props.pagerClassName,
        carouselId: this.state.carouselId,
        clickHandler: clickHandlers[directionName],
        directionName: directionName,
        ref: function ref(el) {
          return _this7["$".concat(directionName, "Btn")] = el;
        },
        style: style
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      // Firefox does not respect `overflow: hidden` and attempts to scroll the carousel
      // when focusing on items in it. Scroll events cannot be canceled with `preventDefault`,
      // so we immediately set the scroll position back to the initial state if the browser
      // attempts to scroll.

      if (this.wrapperRef.current) {
        var domNode = this.wrapperRef.current;
        domNode.scrollLeft = 0;
      }
    }
  }, {
    key: "hasAnyPagers",
    value: function hasAnyPagers() {
      var _this$props3 = this.props,
        showPagerButtons = _this$props3.showPagerButtons,
        showPaginator = _this$props3.showPaginator;
      return Boolean(showPagerButtons || showPaginator);
    }
  }, {
    key: "render",
    value: function render() {
      var _ariaMessages$ariaDes,
        _this8 = this;
      var _this$props4 = this.props,
        activePaginatorClassName = _this$props4.activePaginatorClassName,
        handleTouch = _this$props4.handleTouch,
        showPaginator = _this$props4.showPaginator,
        showControlArrows = _this$props4.showControlArrows,
        controlClassName = _this$props4.controlClassName,
        containerClassName = _this$props4.containerClassName,
        carouselClassName = _this$props4.carouselClassName,
        sliderClassName = _this$props4.sliderClassName;
      var _this$state = this.state,
        ariaMessages = _this$state.ariaMessages,
        carouselId = _this$state.carouselId,
        totalPages = _this$state.totalPages,
        selectedPage = _this$state.selectedPage;
      var descriptionId = this.hasAnyPagers() ? "".concat(carouselId, "-label") : null;
      var ariaDescription = this.hasAnyPagers() ? /*#__PURE__*/_react["default"].createElement("p", {
        className: "hiddenVisually",
        id: descriptionId
      }, (_ariaMessages$ariaDes = ariaMessages.ariaDescription) === null || _ariaMessages$ariaDes === void 0 ? void 0 : _ariaMessages$ariaDes.call(ariaMessages, this.props.children.length)) : null;
      var carouselClassNames = (0, _classnames["default"])(carouselClassName, 'carousel', 'relative');
      var sliderClassNames = (0, _classnames["default"])(sliderClassName, 'carousel__slider');
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: containerClassName,
        ref: this.wrapperRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "aria-describedby": descriptionId,
        "aria-label": ariaMessages.ariaLabel,
        className: carouselClassNames,
        id: carouselId,
        role: "region"
      }, ariaDescription, this.renderPagerButton('prev'), /*#__PURE__*/_react["default"].createElement("div", {
        className: sliderClassNames,
        "data-e2e": "carouselSlider",
        onFocus: this.handleFocus,
        onTouchCancel: handleTouch ? this.handleTouchEnd : noop,
        onTouchEnd: handleTouch ? this.handleTouchEnd : noop,
        onTouchMove: handleTouch ? this.handleTouchMove : noop,
        onTouchStart: handleTouch ? this.createTouchObject : noop,
        ref: function ref(el) {
          return _this8.$slider = el;
        }
      }, this.renderChildren()), this.renderPagerButton('next')), showPaginator && /*#__PURE__*/_react["default"].createElement(_carouselControl["default"], {
        activePaginatorClassName: activePaginatorClassName,
        ariaLabelNext: ariaMessages.ariaLabelNext,
        ariaLabelPages: ariaMessages.ariaLabelPages,
        ariaLabelPrev: ariaMessages.ariaLabelPrev,
        ariaLabelSelected: ariaMessages.ariaLabelSelected,
        className: controlClassName,
        handleClick: this.setCurrentPage,
        handleNextClick: this.slideForward,
        handlePreviousClick: this.slideBack,
        selectedPage: selectedPage,
        showControlArrows: showControlArrows,
        totalPages: totalPages
      }));
    }
  }]);
}(_react.Component);
Carousel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional function which receives a boolean representing whether all
   * children fit in the carousel in the current viewport; runs on every re-render
   */
  areAllSlidesCurrentlyVisible: _propTypes["default"].func,
  children: _propTypes["default"].node,
  /**
   * This class(es) to be used for the main Carousel component.
   */
  carouselClassName: _propTypes["default"].string,
  /**
   * This class(es) will be used to style the container of the Carousel component.
   */
  containerClassName: _propTypes["default"].string,
  /**
   * This class(es) will be used to style the slide container in the Carousel component.
   */
  sliderClassName: _propTypes["default"].string,
  /**
   * This class(es) will modify the pagination control styling.
   * A helper class `isActive` is added whenever a dot is active.
   */
  controlClassName: _propTypes["default"].string,
  /**
   * This class(es) will modify the pager buttons control styling.
   */
  pagerClassName: _propTypes["default"].string,
  /**
   * The easing function to use for the slide animation. See [easings.net](http://easings.net/)
   * for examples.
   */
  easingFunction: _propTypes["default"].oneOf(['linear', 'easeInQuad', 'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic', 'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint', 'easeInOutQuint', 'easeInSine', 'easeOutSine', 'easeInOutSine', 'easeInExpo', 'easeOutExpo', 'easeInOutExpo', 'easeInCirc', 'easeOutCirc', 'easeInOutCirc', 'easeInElastic', 'easeOutElastic', 'easeInOutElastic', 'easeInBack', 'easeOutBack', 'easeInOutBack', 'easeInBounce', 'easeOutBounce', 'easeInOutBounce']).isRequired,
  /**
   * Will get called the new slide index everytime it changes.
   */
  onSlideChange: _propTypes["default"].func.isRequired,
  /**
   * If true, it allows the user to control the carousel with the left/right keys
   */
  globalKeyBindings: _propTypes["default"].bool,
  /**
   * Flag indicating that the carousel should move on touch events. Disable to prevent
   * touch screen users from swiping to change carousel pages.
   */
  handleTouch: _propTypes["default"].bool.isRequired,
  id: _propTypes["default"].string,
  initialCurrentSlide: _propTypes["default"].number,
  /**
   * Id of the element describing the purpose of the carousel. Will be used in conjunction with
   * aria-describedby attribute to create an accessible description of how to interact with the
   * carousel.
   */
  labelledById: _propTypes["default"].string,
  /**
   * Aria labels needed to describe different parts of the carousel.
   *
   * This prop should be an object with the following keys:
   *
   * - `ariaDescription`: This function outlines the overall functionality of the carousel and announces the total number of slides.
   * - `ariaLabel`: labels the carousel.
   * - `ariaLabelSlide`: Name for an individual item in the carousel, e.g 'Slide'.
   * - `ariaLabelNext` label for the 'Next Page' button.
   * - `ariaLabelPrev` label for the 'Previous Page' button.
   * - `ariaLabelPages` this is a function that will label all the page control 'dots'.
   * It will be passed a page number and it must return a string,
   * e.g. `` num => `go to page ${num}` ``.
   * - `ariaLabelSelected` suffix appended to aria-label of selected page control 'dot'.
   * Default value is 'selected' if no value is provided.
   */
  messages: _propTypes["default"].shape({
    ariaDescription: _propTypes["default"].func,
    ariaLabel: _propTypes["default"].string,
    ariaLabelSlide: _propTypes["default"].string,
    ariaLabelNext: _propTypes["default"].string,
    ariaLabelPrev: _propTypes["default"].string,
    ariaLabelPages: _propTypes["default"].func,
    ariaLabelSelected: _propTypes["default"].string
  }),
  /**
   * Optional class applied to slides that are not currently visible.
   */
  inactiveSlideClassName: _propTypes["default"].string,
  /**
   * If true, the carousel will show the previous/next buttons when hovering
   * over the carousel.
   */
  showPagerButtons: _propTypes["default"].bool,
  /**
   * If true, the carousel will always show the previous/next buttons.
   */
  alwaysShowPagerButtons: _propTypes["default"].bool,
  /**
   * If true, the carousel will show the pagination dots.
   */
  showPaginator: _propTypes["default"].bool,
  /**
   * The `isActive` class that gets applied to the active paginator dot.
   */
  activePaginatorClassName: _propTypes["default"].string,
  /**
   * If true, the carousel will show left/right navigation arrows next to the pagination dots. `showPaginator` prop must also be `true`.
   */
  showControlArrows: _propTypes["default"].bool,
  slidesPerPage: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]).isRequired,
  /**
   * The relative springiness of the slide animations. Higher values
   * result in a more forceful animation. Should typically be between
   * 0.5 and 1.5.
   */
  springFactor: _propTypes["default"].number.isRequired,
  /**
   * Duration of slide animations, in milliseconds
   */
  animationDuration: _propTypes["default"].number.isRequired,
  /**
   * Flag indicating that carousel has variable width slides. If this is true, the
   * `slidesPerPage` and `showPaginator` props are ignored and grid items must define
   * their own sizing.
   */
  variableWidth: _propTypes["default"].bool,
  /**
   * Flag indicating that the carousel has images meant to align the pagers. Snaps the
   * pager buttons to the first image in the carousel. Works best if all the images are the same
   * size.
   */
  snapPagersToImages: _propTypes["default"].bool,
  /**
   * Optional time to debounce resize event processing.
   * When the window is resized, the Carousel will wait this amount of milliseconds before
   * re-evaluating the carousel's transform property.
   * If the value is greater than 42, the resize will be performed with animation.
   * This may be useful in cases where
   * many Carousels are being rendered on the same page, and thus limiting re-renders
   * can boost performance.
   */
  resizeDebounceTime: _propTypes["default"].number
} : {};
Carousel.defaultProps = {
  easingFunction: 'easeOutQuad',
  onSlideChange: function onSlideChange() {},
  globalKeyBindings: false,
  handleTouch: true,
  initialCurrentSlide: 0,
  showPagerButtons: true,
  showPaginator: false,
  showControlArrows: false,
  slidesPerPage: 1,
  springFactor: 1,
  animationDuration: 300,
  variableWidth: false,
  snapPagersToImages: false,
  alwaysShowPagerButtons: false,
  areAllSlidesCurrentlyVisible: function areAllSlidesCurrentlyVisible() {},
  resizeDebounceTime: 200
};